import React from 'react';
import { Box } from '@mui/material';
import { DragEndEvent } from '@dnd-kit/core';
import { Comic, ComicGroup, LibraryShelf, LibraryTile } from '../types';
import GroupShelf from './GroupShelf';
import { TileProgress } from './ShelfTile';

interface LibraryViewProps {
  shelves: LibraryShelf[];
  isReadOnly: boolean;
  isMobile: boolean;
  canDrag: boolean;
  tileCover: (tile: LibraryTile) => string | undefined;
  tileProgress: (tile: LibraryTile) => TileProgress | undefined;
  onOpenTile: (tile: LibraryTile) => void;
  onTileMenu: (e: React.MouseEvent<HTMLButtonElement>, tile: LibraryTile) => void;
  onToggleRead: (comic: Comic) => void;
  onGroupMenu: (e: React.MouseEvent<HTMLButtonElement>, group: ComicGroup) => void;
  onDragEnd: (event: DragEndEvent) => void;
  layout?: 'auto' | 'grid';
  hideHeadings?: boolean;
  // Each shelf's own page, if it has one
  sectionHref?: (shelf: LibraryShelf) => string | undefined;
  onOpenSection?: () => void;
}

const LibraryView = ({
  shelves,
  isReadOnly,
  isMobile,
  canDrag,
  tileCover,
  tileProgress,
  onOpenTile,
  onTileMenu,
  onToggleRead,
  onGroupMenu,
  onDragEnd,
  layout = 'auto',
  hideHeadings = false,
  sectionHref,
  onOpenSection,
}: LibraryViewProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {shelves.map((shelf) => (
        <GroupShelf
          key={shelf.key}
          shelf={shelf}
          isReadOnly={isReadOnly}
          isMobile={isMobile}
          canDrag={canDrag}
          tileCover={tileCover}
          tileProgress={tileProgress}
          onOpenTile={onOpenTile}
          onTileMenu={onTileMenu}
          onToggleRead={onToggleRead}
          onGroupMenu={onGroupMenu}
          layout={layout}
          hideHeading={hideHeadings}
          sectionHref={sectionHref?.(shelf)}
          onOpenSection={onOpenSection}
        />
      ))}
    </Box>
  );
};

export default LibraryView;
